import React from 'react';
import { Button } from '@/components/ui/button';

export type MealType = 'breakfast' | 'lunch' | 'dinner';

interface MealTypeTabsProps {
  activeMealType: MealType;
  onMealTypeChange: (mealType: MealType) => void;
  hasBreakfast?: boolean;
  hasLunch?: boolean;
  hasDinner?: boolean;
  isEditable?: boolean;
}

const MealTypeTabs: React.FC<MealTypeTabsProps> = ({
  activeMealType,
  onMealTypeChange,
  hasBreakfast = false,
  hasLunch = false,
  hasDinner = false,
  isEditable = true
}) => {
  if (!isEditable) return null;

  const getDisplayLabel = (type: MealType, isActive: boolean) => {
    if (isActive) {
      switch (type) {
        case 'breakfast': return 'Breakfast';
        case 'lunch': return 'Lunch';
        case 'dinner': return 'Dinner';
      }
    }
    return type === 'breakfast' ? 'B' : type === 'lunch' ? 'L' : 'D';
  };

  const tabs = [
    { type: 'breakfast' as const, hasMeals: hasBreakfast },
    { type: 'lunch' as const, hasMeals: hasLunch },
    { type: 'dinner' as const, hasMeals: hasDinner }
  ];

  return (
    <div className="flex items-center bg-muted/50 rounded-md p-0.5">
      {tabs.map(({ type, hasMeals }) => (
        <button
          key={type}
          onClick={() => onMealTypeChange(type)}
          className={`h-9 px-3 text-xs relative transition-all rounded border-0 outline-none ${
            activeMealType === type 
              ? 'bg-primary text-white font-semibold' 
              : 'text-muted-foreground hover:text-foreground hover:bg-muted active:bg-muted/70 font-medium'
          }`}
        >
          {hasMeals && (
            <div className={`absolute bottom-0.5 right-0.5 w-1.5 h-1.5 rounded-full ${
              activeMealType === type ? 'bg-white' : 'bg-primary'
            }`} />
          )}
          {getDisplayLabel(type, activeMealType === type)}
        </button>
      ))}
    </div>
  );
};

export default MealTypeTabs;